const localization = {
  en: {
    somethingWentWrong: 'Something went wrong'
  },
  es: {
    somethingWentWrong: 'Ha ocurrido un error'
  },
  keyMapping: {
    somethingWentWrong: 'UFD_Error_Text'
  }
}

export default localization
